export default {
  login: {
    title: '登录',
    usernameLabel: '用户名',
    usernamePlaceholder: '2-10位以英文开头的英文数字组合',
    loginPasswordLabel: '登录密码',
    loginPasswordPlaceholder: '请输入你的登录密码',
    googleCodeLabel: '谷歌验证码',
    googleCodePlaceholder: '请输入6位谷歌验证码',
    hasNoAccount: '还没有账号,',
    goRegister: '去注册',
    onlineCustom: '在线客服',
    loginArgument: '继续登录即代表同意',
    userArgument: '《用户协议》',
    registerNotEnabled: '未开放注册功能, 请联系管理员',
    usernameRequired: '请输入正确的用户名',
    loginPasswordRequired: '请输入正确的登录密码',
    googleCodeRequired: '请输入正确的谷歌验证码',
    loginButton: '登录'
  },
  register: {
    title: '注册',
    usernameLabel: '用户名',
    usernamePlaceholder: '请输入注册的用户名',
    loginPasswordLabel: '登录密码',
    loginPasswordPlaceholder: '请输入注册用户的登录密码',
    loginPasswordPreLabel: '确认登录密码',
    loginPasswordPrePlaceholder: '请再次输入登录密码',
    fudPasswordLabel: '资金密码',
    fudPasswordPlaceholder: '请输入资金密码',
    inviteCodeLabel: '邀请码',
    inviteCodePlaceholder: '请输入6位数邀请码',
    registerNeed: '继续注册代表同意',
    registerArgument: '《注册协议》',
    usernameRequired: '请输入正确的用户名',
    loginPasswordRequired: '请输入正确的登录密码',
    loginPasswordPreRequired: '请输入正确的确认登录密码',
    fundPasswordRequired: '请输入正确的资金密码',
    inviteCodeRequired: '请输入正确的邀请码',
    diffLoginPasswordError: '两次登录密码输入不一致',
    registerSuccess: '注册成功',
    registerButton: '注册',
    emailLabel: '邮箱',
    emailPlaceholder: '请输入你的邮箱地址',
    emailCodeLabel: '验证码',
    emailCodePlaceholder: '请输入你的邮箱验证码',
    second: '秒',
    getEmailCodeButton: '获取验证码',
    emailRequired: '请输入正确的邮箱地址后重试',
    emailCodeRequired: '请输入正确的邮箱验证码后重试'
  },
  home: {
    hotCoin: {
      title: '热门交易',
      more: '更多'
    },
    poster: {
      title: '快捷充币',
      enter: '立即进入>',
      subTitle: '支持BTC，USDT，ETH等'
    },
    quickMenus: {
      futuresTrading: '期货交易',
      helpCenter: '帮助中心'
    },
    ranking: {
      increase: {
        title: '涨幅榜'
      },
      clinch: {
        title: '成交额榜'
      }
    }
  },
  tabBar: {
    home: '首页',
    price: '行情',
    trade: '交易',
    fund: '资产',
    user: '我的'
  },
  currency: {
    favorite: '自选',
    allCurrency: '现货',
    dayVol: '24H额',
    addFavor: '+添加自选'
  },
  trade: {
    bills: '订单',
    todayOpen: '开盘',
    star: '自选',
    vol: '成交量',
    low: '最低',
    high: '最高',
    timing: '极速',
    spot: '期货',
    buyMore: '买多',
    buyEmpty: '买空',
    indicator: '指标',
    indicatorSettings: '指标设置',
    balance: '我的余额',
    fee: '服务费',
    ruleIdError: '请选择到期时间',
    deleteFavoriteSuccess: '删除自选币成功',
    addFavoriteSuccess: '添加自选币成功',
    buyIn: '买入',
    sellOut: '卖出',
    holding: '持仓',
    history: '历史',
    spotOrderConfirm: {
      title: '确认买入',
      amountPlaceholder: '请输入购买数量'
    },
    spotTradeOrder: {
      holding: {
        coin: '币种',
        buyInAmountPrice: '买入总价/单价',
        buyInCount: '数量',
        actions: '操作',
        sellOut: '卖出',
        profit: '盈亏'
      }
    },
    orderConfirm: {
      title: '订单确认',
      coinName: '币种',
      direction: '方向',
      price: '现价',
      balance: '余额',
      fee: '服务费',
      buyMoreLabel: '买多',
      buyEmptyLabel: '买空',
      buyQuantity: '买入数量',
      buyAmount: '买入金额',
      submit: '确认订单'
    },
    kline: {
      open: '开:',
      close: '收:',
      change: '涨跌:'
    }
  },
  finance: {
    title: '金融'
  },
  allFinance: {
    title: '理财',
    all: '全部'
  },
  financeOrders: {
    title: '质押订单',
    holdingLabel: '在持',
    historyLabel: '历史',
    holding: {
      amount: '质押金额',
      rateStr: '收益金额/收益率',
      vcCount: '质押币数量',
      cycle: '持仓周期',
      day: '天',
      calcStartDate: '起息日期',
      serviceAmount: '服务费',
      redeemOrder: '赎回'
    },
    history: {
      incomeAmount: '收益金额',
      rateStr: '收益率',
      amount: '质押金额',
      vcCount: '质押币数量',
      calcStartDate: '起息日期',
      calcEndDate: '终息日期',
      cycle: '周期天数',
      serviceAmount: '服务费',
      day: '天'
    }
  },
  financeOrderBills: {
    title: '质押收益账单',
    amount: '金额',
    balance: '余额'
  },
  financeItem: {
    rateStr: '收益率',
    buyType: '买入类型',
    cycle: '周期天数',
    exchangeRate: '兑换汇率(虚拟币兑换余额)',
    day: '天',
    cycleType: '周期类型',
    serviceRateStr: '服务费率'
  },
  buyFinance: {
    title: '购买',
    rateStr: '收益率',
    name: '名称',
    buyType: '买入类型',
    cycle: '周期天数',
    cycleType: '周期类型',
    exchangeRate: '兑换汇率(虚拟币兑换余额)',
    serviceRateStr: '服务费率',
    remark: '备注',
    buyAmountLabel: '买入金额 ({coin})',
    descriptionTitle: '产品说明',
    descriptionPart1: '1.本產品為非保本理財產品，市場波動可能導致本金損失，請謹慎投資.',
    descriptionPart2: '2.回款結算規則：',
    descriptionPart3: '如果結算價＜掛鉤價，到期後結算BTC；結算數量=投資金額*(1+天數*年化收益率/365).',
    descriptionPart4: '如果結算價≥掛鉤價，到期後結算USDT；結算數量=投資金額*掛鉤價*(1+天數*年化收益率/365）.',
    descriptionPart5: '3.實際年化收益率隨市場實時變動，請以實際買入成交為準.',
    descriptionPart6: '4.投資金額隨市場實時折算得出，請以實際買入成交為準.',
    descriptionPart7: '5.產品購買後可在我的持幣頁面進行查看，到期結束後回款會自動發放至現貨賬戶.',
    buyButton: '购买 [{coin}]'
  },
  fund: {
    description: '资产',
    recharge: '充币',
    withdraw: '提币',
    exchange: '划转',
    empty: '钱包空空 去'
  },
  userCenter: {
    lastLogin: '上次登录',
    myTeam: '我的团队',
    identity: '实名认证',
    walletAddress: '钱包地址',
    zskAccount: '转数快账户',
    bankCard: '银行账户',
    userBills: '帐变记录',
    timingTradeOrder: '极速持仓',
    spotTradeOrder: '期货持仓',
    contactTradeOrder: '合约持仓',
    userReport: '用户报表',
    teamReport: '团队报表',
    share: '我要分享',
    customer: '联系客服',
    helpCenter: '帮助中心',
    platform: '平台介绍',
    profit: '今日盈亏',
    balance: '我的余额',
    withdraw: '提币',
    recharge: '充币',
    creditStoreLabel: '信用积分'
  },
  settings: {
    title: '设置',
    fundPassword: '资金密码',
    googleValidator: '谷歌验证器',
    editLoginPassword: '修改登录密码',
    switchLocale: '切换语言'
  },
  editFundPassword: {
    title: '修改资金密码',
    currentPasswordLabel: '当前密码',
    currentPasswordPlaceholder: '请输入当前资金密码',
    newPasswordLabel: '新密码',
    newPasswordPlaceholder: '请输入修改的资金密码',
    prePasswordLabel: '确认密码',
    prePasswordPlaceholder: '清再次输入修改的资金密码',
    tips: '资金密码是进行交易的重要凭证, 清谨慎设置并牢记',
    currentPasswordRequired: '请输入当前的资金密码',
    newPasswordRequired: '请输入要修改的资金密码',
    prePasswordRequired: '请再次输入要修改的资金密码',
    prePasswordDiff: '两次密码输入不一致'
  },
  bindFundPassword: {
    title: '绑定资金密码',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入资金密码',
    fundPasswordPreLabel: '确认密码',
    fundPasswordPrePlaceholder: '请再次输入资金密码',
    fundPasswordRequired: '请输入正确的资金密码',
    fundPasswordPreRequired: '请输入正确的确认密码',
    fundPasswordDiff: '两次密码输入不一致',
    bindSuccess: '资金密码绑定成功',
    tips: '资金密码是进行交易的重要凭证, 请谨慎设置并牢记'
  },
  editLoginPassword: {
    title: '修改登录密码',
    currentPasswordLabel: '当前密码',
    currentPasswordPlaceholder: '请输入当前登录密码',
    newPasswordLabel: '新密码',
    newPasswordPlaceholder: '请输入修改的登录密码',
    prePasswordLabel: '确认密码',
    prePasswordPlaceholder: '清再次输入修改的登录密码',
    tips: '登录密码是进行登录认证等的重要凭证, 请谨慎设置并牢记',
    currentPasswordRequired: '请输入当前的登录密码',
    newPasswordRequired: '请输入要修改的登录密码',
    prePasswordRequired: '请再次输入要修改的登录密码',
    prePasswordDiff: '两次密码输入不一致'
  },
  bindGoogleValidator: {
    title: '绑定谷歌验证器',
    qrCodeLabel: '二维码',
    keyLabel: '密钥',
    loginPasswordLabel: '登录密码',
    loginPasswordPlaceholder: '请输入你的登录密码',
    googleCodeLabel: '谷歌验证码',
    googleCodePlaceholder: '请输入6位谷歌验证码',
    tipsPart1: '在应用商店搜索谷歌验证器',
    tipsPart2: '使用谷歌验证器扫描上图二维码, 或手动输入密钥进行绑定',
    tipsPart3: '在上方输入6位谷歌验证码, 点击确认提交',
    loginPasswordRequired: '请输入登录密码',
    googleCodeRequired: '请输入6位谷歌验证码'
  },
  walletAddress: {
    title: '钱包地址',
    add: '+ 添加钱包地址',
    remark: '备注',
    addButton: '添加钱包地址',
    tips: '若要修改或删除地址信息，请联系客服'
  },
  addWalletAddress: {
    title: '添加钱包地址',
    vcChainNameIdLabel: '链类型',
    vcAccountLabel: '钱包地址',
    vcAccountPlaceholder: '请输入钱包地址',
    remarkLabel: '备注',
    remarkPlaceholder: '请输入备注内容',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入你的资金密码',
    tips: '添加后的钱包地址不可修改, 请核实信息无误',
    vcIdRequired: '请选择正确的币种',
    vcChainNameIdRequired: '请选择正确的链类型',
    vcAccountRequired: '请输入正确的钱包地址',
    fundPwdRequired: '请输入正确的资金密码',
    addSuccess: '钱包地址添加成功'
  },
  receiveWays: {
    title: '我的银行卡',
    add: '+ 添加银行卡',
    tips: '若要修改或者删除银行卡信息，请联系客服',
    addCardButton: '添加银行卡'
  },
  zskAccount: {
    title: '转数快账户',
    add: '+ 添加转数快账户',
    tips: '若要修改或删除账户信息, 请联系客服',
    addCardButton: '添加账户'
  },
  addZskAccount: {
    title: '新增转数快账户',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '请输入姓名',
    withdrawNameRequired: '姓名不允许为空',
    zskLabel: '转数快',
    zskPlaceholder: '请输入转数快',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入你的资金密码',
    tips: '请谨慎填写添加账户的信息, 如因为信息填写错误导致提现不到账的问题, 公司概不负责'
  },
  addBankCard: {
    title: '新增银行卡',
    cardNumLabel: '银行卡号',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '请输入姓名',
    withdrawNameRequired: '姓名不允许为空',
    zskLabel: '转数快',
    zskPlaceholder: '请输入转数快',
    zskRequired: '请输入正确的转数快',
    cardNumPlaceholder: '请输入银行卡号',
    branchLabel: '支行地址',
    branchPlaceholder: '请输入银行卡支行地址',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入资金密码',
    tips: '银行卡是进行交易提现的重要数据, 请谨慎填写, 如因卡信息填写错误导致提现不到账等问题, 公司概不负责。',
    backIdRequired: '请选择开户行',
    cardNumRequired: '请输入正确的银行卡号',
    fundPwdRequired: '请输入正确的资金密码',
    idCardPlaceholder: '请输入身份证号',
    idCardLabel: '身份证号',
    idCardRequired: '请输入正确的身份证号',
    cciPlaceholder: '请输入银行卡CCI',
    branchCodePlaceholder: '请输入支行编号',
    branchCodeLabel: '支行编号',
    katakanaPlaceholder: '请输入片假名',
    katakanaLabel: '片假名'
  },
  userBills: {
    title: '帐变记录',
    vcName: '币种',
    amount: '金额',
    balance: '余额'
  },
  timingTradeOrder: {
    title: '极速交易订单',
    waiting: {
      title: '在持订单',
      amount: '金额',
      period: '周期',
      receivePrice: '买入价',
      settlement: '结算中'
    },
    history: {
      title: '历史订单',
      buyInClose: '买入价',
      saleOutClose: '卖出价'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: '用户报表',
    profit: '盈利',
    timingTradeAmountFee: '极速交易下单/手续费',
    timingTradePrizePoint: '极速交易奖金/返点',
    rechargeInfo: '充值/手续费',
    withdrawInfo: '提现/手续费',
    exchangeInfo: '兑换/手续费'
  },
  userReportDay: {
    title: '用户日报表',
    profit: '盈利',
    timingTradeAmountFee: '极速交易下单/手续费',
    timingTradePrizePoint: '极速交易奖金/返点',
    rechargeInfo: '充值/手续费',
    withdrawInfo: '提现/手续费',
    exchangeInfo: '兑换/手续费'
  },
  teamReport: {
    title: '团队报表',
    goToReportDay: '查看日报表',
    timingTradeBetAmountServiceCharge: '极速交易下单/服务费',
    timingTradeBetPrizePoint: '极速交易奖金/返点',
    timingTradeUserAndCount: '极速交易人数/笔数',
    rechargeAmountFee: '充值金额/服务费',
    rechargePersonCount: '充值人数/笔数',
    withdrawAmountFee: '提币金额/服务费',
    withdrawPersonCount: '提币人数/笔数',
    firstRechargeUserAndCount: '首充金额/人数',
    usernamePlaceholder: '输入下级用户名',
    previewAllTradeInfo: '查看所有极速交易信息',
    coin: '币种',
    timingTradeBetAmount: '极速交易投注金额',
    profit: '盈利',
    action: '操作',
    previewReportDay: '查看日报表'
  },
  teamTimingTradeInfo: {
    title: '团队极速交易',
    profit: '盈利',
    subTitle: '团队极速交易信息',
    timingTradeAmountFee: '极速交易下单/服务费',
    timingTradePrizePoint: '极速交易奖金/返点',
    rechargeInfo: '充值/服务费',
    withdrawInfo: '提现/服务费',
    exchangeInfo: '兑换/服务费'
  },
  teamReportDay: {
    title: '团队日报表',
    subTitle: '团队 [ {username} ]日报表',
    timingTradeBetAmountFee: '极速交易下单/服务费',
    timingTradeBetPrizePoint: '极速交易奖金/返点',
    rechargeAmountFee: '充值金额/服务费',
    rechargePersonCount: '充值人数/笔数',
    timingTradeUserAndCount: '极速交易人数/笔数',
    firstRechargePersonCount: '首充金额/笔数',
    withdrawAmountFee: '提币金额/服务费',
    withdrawPersonCount: '提币人数/笔数',
    exchangeAmountFee: '兑换金额/服务费'
  },
  share: {
    title: '我要分享',
    qrCodeLabel: '二维码',
    registerUrlLabel: '注册地址',
    inviteCodeLabel: '邀请码',
    hasNoInviteCode: '当前账户没有邀请码,',
    generateInvitationCode: '试试一键生成',
    tipsPart1: '扫描以上二维码填写注册信息进行注册',
    tipsPart2: '复制注册地址填写注册信息进行注册',
    tipsPart3: '手动打开本站点注册界面填写邀请码进行注册',
    saveImageError: '图片保存失败，试试长按图片并保存'
  },
  myTeam: {
    title: '我的团队',
    usernamePlaceholder: '输入下级用户名',
    point: '返点(极速/合约)',
    totalBalance: '余额',
    lastLoginTime: '上次登录时间',
    noLoginTime: '无'
  },
  userDetail: {
    username: '用户名',
    userType: '用户类型',
    title: '用户详情',
    pointPercentTiming: '极速交易返点',
    pointPercentContract: '合约交易返点',
    registerWay: '注册方式',
    teamCounts: '团队人数',
    teamOnline: '团队在线',
    balance: '余额',
    registerTime: '注册时间',
    onlineStatus: '登录状态'
  },
  addUser: {
    title: '新增用户',
    addUserDirect: {
      userTypeLabel: '用户类型',
      usernameLabel: '用户名',
      usernamePlaceholder: '请输入开户用户名',
      pointTimingLabel: '极速交易返点',
      pointContractLabel: '合约交易返点',
      tips: '初始密码为: "{password}"; 开户后请及时提醒用户修改密码',
      userTypeRequired: '请选择开户类型',
      usernameRequired: '请输入开户用户名',
      pointTimingRequired: '请选择极速交易返点',
      pointContractRequired: '请选择合约交易返点',
      copyTemplate: `
        用户名: {username};
        登录密码: {loginPassword};
        登录网址: {loginAddress};
        极速交易返点: {timingTradePoint};
        合约交易返点: {contactTradePoint};
        `
    }
  },
  recharge: {
    title: '充币',
    configIdLabel: '充币通道',
    chainNameLabel: '链名称',
    amountLabel: '充值金额',
    userCardNameLabel: '付款人',
    userCardNamePlaceholder: '请输入付款人姓名',
    fee: '服务费',
    receiveAmountTipsPart1: '充值',
    receiveAmountTipsPart2: ', 需支付',
    tipsPart1: '因为在线支付接口不稳定，目前仅支持线下转账充值！',
    tipsPart2: '请如实填写实际转账金额，否则可能导致系统审核无法通过，影响充值进度。',
    emptyPart1: '暂无可用的充值通道, ',
    emptyPart2: '轻触重试',
    amountRequired: '充值金额不能为空',
    maxPrecisionError: '充值金额最多{amountMaxPrecision}位小数',
    payUserNameError: '请输入正确的付款人后重试',
    userMobileLabel: '手机号',
    userMobilePlaceholder: '请输入用户手机号',
    needPayLabel: '需支付',
    needPayPlaceholder: '点击输入金额'
  },
  payDetail: {
    title: '转账信息',
    addressLabel: '充币地址',
    rechargeAmount: '充币金额',
    bankNameLabel: '银行',
    branchLabel: '支行地址',
    cardName: '姓名',
    cardNum: '卡号',
    uploadImgLabel: '支付凭证',
    uploadImgPlaceholder: '点击上传支付凭证图片',
    uploadImgRequired: '请上传支付凭证图片',
    vcTransferTipsPart1: '1. 复制充币地址或扫描二维码进行充币',
    vcTransferTipsPart2: '2. 充币完成后上传支付凭证图片',
    vcTransferTipsPart3: '为提高充币的效率, 请确保上传清晰高清的凭证图片, 如相关信息图片不清晰可能导致系统审核无法通过，影响充值进度。',
    bankCardTips: '为提高充币的效率, 请确保使用填写的转账人与汇款人名称一致; 如相关信息不符合可能导致系统审核无法通过，影响充值进度。',
    bankCardTransferSuccess: '我已转账成功'
  },
  rechargeOrder: {
    title: '充币订单',
    payAmount: '充值金额',
    receiveAmount: '到账金额'
  },
  identity: {
    title: '实名信息',
    subTitle: '实名认证包括信息认证, 身份认证',
    name: '姓名',
    idType: '证件类型',
    idNum: '证件号码',
    demand: '要求',
    informationVer: '信息认证',
    idAuthentication: '身份认证',
    material: '材料'
  },
  verified: {
    title: '实名认证',
    idCardTypeLabel: '证件类型',
    idCardFrontSideImgLabel: '证件照正面',
    idCardBackSideImgLabel: '证件照背面',
    idCardHandSideImgLabel: '手持证件照',
    nameLabel: '证件姓名',
    namePlaceholder: '请输入你的证件姓名',
    idCardNumLabel: '证件号码',
    idCardNumPlaceholder: '请输入证件号码',
    fundPwdLabel: '资金密码',
    fundPwdPlaceholder: '请输入你的资金密码',
    tips: '信息认证一旦提交，不可修改，请谨慎核对后正确填入',
    idCardTypeRequired: '请选择证件类型',
    idCardFrontSideImgRequired: '请上传证件正面照',
    idCardBackSideImgRequired: '请上传证件背面照',
    idCardHandSideImgRequired: '请上传手持证件照',
    nameRequired: '请输入证件姓名',
    idCardNumRequired: '请输入证件号码',
    fundPwdRequired: '请输入你的资金密码',
    submitSuccess: '认证请求提交成功'
  },
  help: {
    title: '帮助中心'
  },
  helpDetail: {
    title: '帮助详情'
  },
  myMessage: {
    title: '我的私信'
  },
  messageDetail: {
    title: '私信详情'
  },
  withdraw: {
    title: '提币',
    tips: '为保证资金安全及提现效率; 请仔细核对所填写信息无误, 提币过程中产生的手续费将从余额中扣除',
    receiveAmountTipsPart1: '提现',
    receiveAmountTipsPart2: ', 预计到账',
    fee: '服务费',
    myBalance: '我的 [ {vcName} ] 余额:',
    configIdLabel: '提币通道',
    amountLabel: '提币金额',
    fundLabel: '资金密码',
    fundPlaceholder: '请输入你的资金密码',
    googleCodeLabel: '谷歌验证码',
    googleCodePlaceholder: '请输入6位谷歌验证码',
    maxPrecisionError: '提币金额最多{amountMaxPrecision}位小数',
    amountRequired: '请输入或选择正确的提币金额',
    bankCardError: '请选择正确的银行卡',
    fundPwdError: '请输入正确的资金密码',
    walletAddressError: '请选择正确的钱包地址',
    success: '提现请求提交成功, 请等待处理',
    emptyPart1: '暂无可用的提币通道, ',
    emptyPart2: '轻触重试'
  },
  withdrawOrder: {
    title: '提币订单',
    requestAmount: '提单金额',
    receiveAmount: '到账金额'
  },
  locales: {
    title: '切换语言'
  },
  lines: {
    title: '线路选择',
    switchLine: '切换线路'
  },
  currencyPop: {
    deleteFavoriteSuccess: '删除自选币成功',
    addFavoriteSuccess: '添加自选币成功'
  },
  currencySelect: {
    currencyName: '币种',
    currencyPlaceholder: '点击选择币种'
  },
  walletItem: {
    available: '可用',
    convert: '折合(USDT)'
  },
  banks: {
    bankIdLabel: '银行',
    bankIdPlaceholder: '点击选择银行'
  },
  banksPop: {
    title: '选择银行',
    search: '输入银行关键字'
  },
  historyOrderDetail: {
    title: '订单详情',
    coin: '交易币种',
    amount: '下单金额',
    buyInClose: '买入价',
    sellOutClose: '卖出价',
    isQuest: '对此订单有疑问?',
    connectCustomer: '联系客服?'
  },
  pointSelect: {
    prizeGroupPlaceholder: '点击选择用户返点'
  },
  walletAddressSelect: {
    title: '选择钱包地址',
    label: '钱包地址',
    placeholder: '点击选择钱包地址'
  },
  myCardSelect: {
    title: '选择账户',
    label: '收款账户',
    placeholder: '点击选择账户'
  },
  amountInput: {
    amountRange: '最小 {minAmount}, 最大{maxAmount}',
    amountMin: '最小 {minAmount}, 上不封顶',
    amountErrorEmpty: '{label}有误, 请核实后重试',
    amountErrorOutRange: '{label}超出范围, 请核实后重试'
  },
  amountFormItem: {
    placeholderOnlyMin: '最小 {minAmount}, 上不封顶',
    placeholderHasMax: '最小 {minAmount}, 最大{maxAmount}',
    amountErrorEmpty: '金额有误, 请核实后重试',
    amountErrorOutRange: '金额超出范围, 请核实后重试'
  },
  common: {
    remark: '备注',
    saveImage: '保存本地',
    online: '在线',
    offline: '已下线',
    profit: '盈亏',
    date: '日期',
    period: '周期',
    pointAmount: '用户返点金额',
    point: '用户返点',
    direction: '方向',
    winLoss: '收益',
    lose: '输',
    add: '新增',
    win: '赢',
    edit: '修改',
    notBind: '未绑定',
    alreadyBind: '已绑定',
    enabled: '已启用',
    notEnabled: '未启用',
    queryRange: '查询范围',
    copy: '复制',
    orderNum: '订单号',
    null: '无',
    noData: '暂无数据',
    refreshSuccess: '刷新成功',
    loadMoreData: '加载更多数据',
    noMoreData: '没有更多数据了',
    lookMore: '查看更多',
    more: '更多'
  },
  date: {
    today: '今天',
    yesterday: '昨天',
    last7Days: '近7天',
    last14Days: '近14天',
    split: '至'
  },
  button: {
    save: '保存',
    logout: '登出',
    confirm: '确定',
    cancel: '取消',
    submit: '提交',
    addNow: '立即添加',
    reset: '重置',
    nextStep: '下一步',
    goCertification: '去认证'
  },
  confirm: {
    title: {
      logout: '退出登录',
      unBindFundPassword: '未绑定资金密码',
      addUserDirect: '新增用户',
      addUserInfo: '新增用户成功',
      jumpToRechargePage: '确认跳转',
      unAuthentication: '未实名认证',
      noBindBankCard: '未添加银行卡',
      noBindCoinAddress: '未添加钱包地址',
      tradeConfirm: '确认交易',
      sellOutSpotOrder: '持仓卖出',
      buyFinance: '确认购买',
      redeemOrder: '質押訂單贖回'
    },
    content: {
      logout: '是否确认退出当前账号?',
      unBindFundPassword: '检测到未绑定资金密码, 为保证账号安全，请先绑定你的资金密码',
      addUserDirect: '即将新增用户, 请核实填写信息无误后点击确认继续, 用户名[ {username} ], 用户类型[ {userType} ], 登录密码[ {password} ], 与我的极速交易返点差额[ {diffPointTiming} ], 与我的合约交易返点差额[ {diffPointContract} ]',
      addUserInfo: '用户名[ {username} ]; <br /> 登录密码[ {password} ];<br /> 登录网址[ {loginAddress} ];<br /> 极速交易返点[ {pointPercentTiming} ];<br /> 合约交易返点[ {pointPercentContract} ]；',
      jumpToRechargePage: '即将跳转三方充值界面，请点击确认继续',
      unAuthentication: '检测到账户没有进行实名认证， 为保证资金正常流通， 请先进行实名认证',
      noBindBankCard: '检测到账户没有绑定或启用的银行卡，为保证资金正常流通，请先添加银行卡',
      noBindCoinAddress: '检测到账户没有绑定或启用的虚拟币账户，为保证资金正常流通，请先添加虚拟币账户地址',
      tradeConfirm: '即将提交订单, 请核实订单信息无误后点击确认订单进行提交',
      sellOutSpotOrder: '即将卖出持仓订单, 请确认操作无误后点击确认继续',
      buyFinance: '即将买入[{coin}], 买入份额: {amount}, 请确认操作无误后点击确认继续',
      redeemOrder: '即將贖回質押訂單({orderNum}), 請確認操作無誤後點擊確認繼續'
    }
  },
  message: {
    bindSuccess: '绑定成功',
    successOperation: '操作成功',
    logoutSuccess: '退出成功',
    editSuccess: '修改成功',
    addSuccess: '添加成功',
    copySuccess: '复制成功',
    copyFailed: '复制失败'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '日',
      week_day_1: '一',
      week_day_2: '二',
      week_day_3: '三',
      week_day_4: '四',
      week_day_5: '五',
      week_day_6: '六'
    },
    loading: {
      loading: '加载中'
    }
  },
  helpItems: {
    title: {
      part1: '资产中的折合金额为什么会产生变化？',
      part2: '忘记OTC交易的资金密码处理办法',
      part3: 'OTC交易买入完成后的资金流向哪里？',
      part4: '为什么要限制修改昵称的次数',
      part5: '划转是什么意思，为什么需要划转',
      part6: '如何计算用户合约的账户权益？',
      part7: '开仓中设定的止损止盈的数值作用是什么？应当如何设定？',
      part8: '如何降低合约风险度？',
      part9: '合约开仓中的数量表示什么？',
      part10: '关于强制平仓的说明',
      part11: '合约交易规则是什么？',
      part12: '合约交易中的保证金是什么？',
      part13: '什么是限价委托和市价委托？',
      part14: '合约交易的风险度代表什么',
      part15: '为什么需要进行币种兑换？',
      part16: '为什么在OTC交易转账后，对方未及时收到转款？',
      part17: '如何通过OTC购买泰达币（USDT）？'
    },
    content: {
      part1: '资产中折合计算的时当前持有数字货币折合人名币的价值，因数字资产的价格波动而变化。您的数字资产数量并没有改变。',
      part2: '如果你忘记OTC交易资金密码，请到“我的-设置-点击设置资金密码”或联系客服进行重置',
      part3: 'OTC买入订单完成后，资金将进入资产中的法币账户。若需要将OTC买入资产进行合约交易或期货交易，请至资金划转模块进行划转。',
      part4: '出于您交易的安全原因，目前我们限制昵称只能修改一次。',
      part5: '为了保障您的各个账户之间的资金独立，有利于您进行合理的风险控制，特此将各大交易模块的账户进行划分。划转是指各个交易账户之间的资产进行互相转换的过程。',
      part6: '<p>合约账户权益，计算方法如下：</p> <p>合约账户权益=持仓保证金+持仓浮动盈亏+当前账户可用金额</p>',
      part7: '止盈止损作为您设定的盈利上限和损失上限，达到设定的止盈止损金额，系统将自动平仓。可用于您在购买合约时的风险控制，一半设定的止盈数额为：涨幅金额x数量x杠杆倍数，设定的止损我们建议您根据自己的实际资产情况进行设定，合理控制风险。',
      part8: '您可以通过资金划转的方式，将其余账户的可用资产划入合约账户，或通过减少持仓，来降低风险度。',
      part9: '开仓中的数量表示您期望买入的币种数量。例如：在BTC/USDT交易对的开仓页面中选择，买入做多，输入价格为1000USDT，输入数量为10BTC，则表示：您期望买入10个单价为1000USDT的BTC。',
      part10: '<p>风险度是衡量您的资产风险的指标，当风险度等于100%时，您的仓位被视为爆仓，风险度=（持仓保证金/合约账户权益）*100%，为了防止用户穿仓，系统设定了风险度的调整比例，当风险度达到系统设定的风险值，系统将强制平仓。例如：系统设定的调整比例为10%，则当您的风险度大于等于90%时，您的所有仓位都将会被系统强制平仓。</p> <p>注：若是风险度超标导致的系统强制平仓，是将您所有仓位都进行平仓，因此希望您可以合理的控制您的风险度，以免因此造成不必要的损失 </p>',
      part11: '<p> 交易类型</p> <p>交易类型分为开仓做多（买入）和开仓做空（卖出）两个方向：</p> <p>买入做多（看涨）是指您认为当前指数有涨的可能，希望以您设定的价格或者当前市价，新买入一定数量的某种合约。</p> <p>卖出做空（看跌）是指您认为当前指数有跌的可能，希望以您设定的价格或当前市价，新卖出一定数量的某种合约。</p> <p>下单方式</p> <p>限价委托：您需要自己指定下单的价格和数量</p> <p>市价委托：您只需设定下单的数量，价格为当前市场价格</p> <p>持仓</p> <p>当您提交的开仓委托单成交后即称之为持仓</p> <p>合约交割问题</p> <p>平台合约为永续合约，无设定交割时间。只要未达到系统爆仓条件或您 未手动平仓，您可永久持仓。</p> <p>系统平仓</p> <p>1：达到止盈止损设定值，系统自动平仓</p> <p>2：风险度过高，系统强制平仓</p>',
      part12: '<p>在合约交易中，用户根据合约价格和数量，根据对应的杠杆倍数，缴纳资金作为欸履行合约的财力担保，便可参与合约的买卖，这种资金就是合约保证金。用户开仓将占用保证金，占用的开仓保证金越多，账户风险越高。</p> <p>保证金=（开仓价格*数量）/杠杆倍数</p>',
      part13: '限价委托指的是您期望以什么价格委托平台进行交易，市价委托是指直接以当前价格委托平台进行交易。在开仓交易的规则中，市价委托是优先于限价委托进行交易的。若您选择限价委托请合理根据当前货币的行情价格进行开仓，避免因不合理的开仓价格造成损失。',
      part14: '风险度是您合约账户中风险指标，风险度等于100%被视为爆仓。我们建议您，当您的风险度超过50%时，需要谨慎开仓，以免因为爆仓而造成损失。可通过补充合约资产的可用资金，或减少持仓来降低您的风险。',
      part15: '兑换的作用是为了让您的资产中不同币种的资金可以进行顺畅的流通，期货账户中获得的QCC可自由转换成USDT进行交易。其他账户中的USDT也可自由的转换成QCC进行交易。',
      part16: '首先请确保您转账时填写的收款方式和订单详情页的显示的完全一致。然后请确认您的付款方式是即时到账的，还是延迟到账的。最后请联系您的银行和支付机构，是否有系统维护或其他原因。',
      part17: '<p>方式一：通过OTC购买和售出列表选择您想要购买的订单进行买卖。</p> <p>方式二：点击发布按钮，根据自己的需求发布买单或者卖单进行快速交易。系统将快速为您匹配买卖用户。</p> <p>注：买入订单在15分钟后若未支付，系统将自动取消订单，请您及时支付。若当日取消订单超过3次，当日无法再次进行交易，次日恢复交易权限。</p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/zh-CN.js